import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { Modal } from "react-bootstrap";
import "./Modal.css";
import "./DirectionsDialog.css";
import MultiSelectModal from "./MultiSelectModal";
import AlertModal from "./AlertModal";
import { useDispatch } from "react-redux";
import { slice1Actions } from "../../store/reducer";
import { useSelector } from "react-redux";
import Place from "../../Models/Place";

const DirectionsDialog = (props) => {
  const dispatch = useDispatch();
  // const [DirectionsFromPlace, setDirectionsFromPlace] = useState([]);
  // const [DirectionsToPlace, setDirectionsToPlace] = useState([]);
  // const [DirectionsWaypoints, setDirectionsWaypoints] = useState([]);
  const [which_one, set_which_one] = useState("from");

  const [MultiselectItems, setMultiselectItems] = useState([]);
  const [MultiselectSelectedItems, setMultiselectSelectedItems] = useState([]);
  const [MultiselectMode, setMultiselectMode] = useState("uni");
  //const [MultiselectCallback, setMultiselectCallback] = useState(null);
  const [MultiselectTitle, setMultiselectTitle] = useState("Select");
  const [MultiselectSearchText] = useState("");
  const [ShowMultiselect, setShowMultiselect] = useState(null);
  const [AlertModalShow, setAlertModalShow] = useState(false);
  const [AlertModalTitle, setAlertModalTitle] = useState("");
  const [AlertModalMessage, setAlertModalMessage] = useState("");
  const [AlertModalButtons, setAlertModalButtons] = useState([]);
  const [TravelMode, setTravelMode] = useState("Walking");
  const [ShapeToCreate, setShapeToCreate] = useState("Path");
  const [Operation, setOperation] = useState("Directions");

  let DirectionsFromLocation = useSelector((state) => state.DirectionsFromLocation);
  let DirectionsToLocation = useSelector((state) => state.DirectionsToLocation);
  let DirectionsWaypointsLocation = useSelector((state) => state.DirectionsWaypointsLocation);

  useEffect(() => {
    // if (fromLoc != null) setDirectionsFromLocation(fromLoc);
    // if (toLoc != null) setDirectionsToLocation(toLoc);
    // if (waypointsArray.length !== 0) DirectionsWaypointsLocation(waypointsArray);
    if (typeof window.DirectionsWaypointPlaces === "undefined") window.DirectionsWaypointPlaces = [];
    if (typeof window.DirectionsFromPlace === "undefined") window.DirectionsFromPlace = [];
    if (typeof window.DirectionsToPlace === "undefined") window.DirectionsToPlace = [];
    if (window.DirectionsFromLocation === null) {
      const _place = window.guide_obj.places.getPlace(props.id);
      if (_place !== null) {
        window.DirectionsFromLocation = { Name: _place.Name, Lat: _place.Lat, Longi: _place.Longi };
        dispatch(
          slice1Actions.setDirectionsFromLocation({
            value: { Name: _place.Name, Lat: _place.Lat, Longi: _place.Longi },
          })
        );
      }
    } else if (window.DirectionsToLocation === null) {
      const _place = window.guide_obj.places.getPlace(props.id);
      if (_place !== null) {
        if (
          window.DirectionsFromLocation.Name !== _place.Name ||
          window.DirectionsFromLocation.Lat !== _place.Lat ||
          window.DirectionsFromLocation.Longi !== _place.Longi
        ) {
          window.DirectionsToLocation = { Name: _place.Name, Lat: _place.Lat, Longi: _place.Longi };
          dispatch(
            slice1Actions.setDirectionsToLocation({
              value: { Name: _place.Name, Lat: _place.Lat, Longi: _place.Longi },
            })
          );
        }
      }
    }
  }, [props.id]);

  const selectPlaces = (which) => {
    set_which_one(which);
    let selectedPlaces = [];
    let Places =
      which === "waypoints"
        ? window.DirectionsWaypointPlaces
        : which === "from place"
        ? window.DirectionsFromPlace
        : window.DirectionsToPlace;
    Places.forEach((place) =>
      selectedPlaces.push({
        label: place.Name,
        name: place.Name,
        value: place.ID,
      })
    );
    setMultiselectItems(window.guide_obj.places.getPlacesToDisplay(null));
    setMultiselectSelectedItems(selectedPlaces);
    setMultiselectMode(which === "waypoints" ? "multi" : "uni");
    setMultiselectTitle(`Select ${which}`);
    setShowMultiselect(true);
  };

  const selectPlacesCallBack = (Places) => {
    let _places = [];
    Places.forEach((place) => {
      _places.push({
        Name: place.label,
        ID: place.value,
      });
    });
    if (which_one === "waypoints") {
      let locs = [];
      _places.forEach((place) => {
        const _place = window.guide_obj.places.getPlace(place.ID);
        if (_place !== null) locs.push({ Name: _place.Name, Lat: _place.Lat, Longi: _place.Longi });
      });
      window.DirectionsWaypointPlaces = _places;
      dispatch(slice1Actions.setDirectionsWaypointsLocation({ value: locs }));
      window.DirectionsWaypointsLocation = locs;
    } else if (which_one === "from place") {
      if (_places.length === 0) return;
      const _place = window.guide_obj.places.getPlace(_places[0].ID);
      if (_place !== null) {
        window.DirectionsFromPlace = _places;
        dispatch(
          slice1Actions.setDirectionsFromLocation({
            value: { Name: _place.Name, Lat: _place.Lat, Longi: _place.Longi },
          })
        );
        window.DirectionsFromLocation = { Name: _place.Name, Lat: _place.Lat, Longi: _place.Longi };
      }
    } else {
      if (_places.length === 0) return;
      const _place = window.guide_obj.places.getPlace(_places[0].ID);
      if (_place !== null) {
        window.DirectionsToPlace = _places;
        window.DirectionsToLocation = { Name: _place.Name, Lat: _place.Lat, Longi: _place.Longi };
        dispatch(
          slice1Actions.setDirectionsToLocation({
            value: { Name: _place.Name, Lat: _place.Lat, Longi: _place.Longi },
          })
        );
        window.DirectionsToLocation = { Name: _place.Name, Lat: _place.Lat, Longi: _place.Longi };
      }
    }
  };

  const createPath = () => {
    if (window.DirectionsFromLocation === null) {
      myAlert("Must select 'From' place");
      return;
    }
    if (window.DirectionsToLocation === null) {
      myAlert("Must select 'To' place");
      return;
    }
    shapeFromDirections();
    exitDialog();
  };

  const decodePolyline = (encoded) => {
    const pts = [];
    let idx = 0, lat = 0, lng = 0;
    while (idx < encoded.length) {
      let shift = 0, result = 0, b;
      do { b = encoded.charCodeAt(idx++) - 63; result |= (b & 0x1f) << shift; shift += 5; } while (b >= 0x20);
      lat += (result & 1) ? ~(result >> 1) : (result >> 1);
      shift = result = 0;
      do { b = encoded.charCodeAt(idx++) - 63; result |= (b & 0x1f) << shift; shift += 5; } while (b >= 0x20);
      lng += (result & 1) ? ~(result >> 1) : (result >> 1);
      pts.push({ lat: lat / 1e5, lng: lng / 1e5 });
    }
    return pts;
  };

  const formatDistance = (meters) => {
    if (meters < 1000) return `${meters} m`;
    return `${(meters / 1000).toFixed(1)} km`;
  };

  const formatDuration = (durationStr) => {
    const seconds = parseInt(durationStr, 10) || 0;
    if (seconds < 60) return `${seconds} sec`;
    const minutes = Math.round(seconds / 60);
    if (minutes < 60) return `${minutes} min`;
    const hours = Math.floor(minutes / 60);
    const rem = minutes % 60;
    return rem > 0 ? `${hours} hr ${rem} min` : `${hours} hr`;
  };

  const shapeFromDirections = async () => {
    const apiKey = process.env.REACT_APP_ROUTES_API_KEY || process.env.REACT_APP_GOOGLE_MAPS_KEY;
    const name = `${window.DirectionsFromLocation.Name}-${window.DirectionsToLocation.Name}`;
    const travelModeMap = { Walking: "WALK", Bicycling: "BICYCLE", Driving: "DRIVE" };
    const reqBody = {
      origin: { location: { latLng: { latitude: window.DirectionsFromLocation.Lat, longitude: window.DirectionsFromLocation.Longi } } },
      destination: { location: { latLng: { latitude: window.DirectionsToLocation.Lat, longitude: window.DirectionsToLocation.Longi } } },
      travelMode: travelModeMap[TravelMode] || "WALK",
      languageCode: "en-US",
    };
    if (window.DirectionsWaypointsLocation.length > 0)
      reqBody.intermediates = window.DirectionsWaypointsLocation.map((wp) => ({
        location: { latLng: { latitude: wp.Lat, longitude: wp.Longi } },
      }));
    try {
      const response = await fetch("https://routes.googleapis.com/directions/v2:computeRoutes", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Goog-Api-Key": apiKey,
          "X-Goog-FieldMask": "routes.polyline.encodedPolyline,routes.legs.distanceMeters,routes.legs.duration,routes.legs.steps.navigationInstruction",
        },
        body: JSON.stringify(reqBody),
      });
      if (!response.ok) {
        console.error("Routes API error:", await response.text());
        myAlert("Failed to get directions");
        return;
      }
      const data = await response.json();
      const route = data.routes?.[0];
      if (!route) { myAlert("No route found"); return; }
      const decoded = decodePolyline(route.polyline.encodedPolyline);
      const mapCoordinate = { Lat: decoded[0].lat, Longi: decoded[0].lng };
      const points = decoded.map((p) => `${p.lng.toFixed(6)},${p.lat.toFixed(6)}`).join(":");
      let directions = "";
      if (route.legs) {
        for (const leg of route.legs)
          if (leg.steps)
            for (const step of leg.steps)
              if (step.navigationInstruction?.instructions)
                directions += step.navigationInstruction.instructions + "<br/>";
        const firstLeg = route.legs[0];
        if (firstLeg)
          directions += `Distance: ${formatDistance(firstLeg.distanceMeters || 0)}, Time: ${formatDuration(firstLeg.duration || "0s")}`;
      }
      if (ShapeToCreate === "Path") addPlaceToMap("PolyLine", points, directions, name, mapCoordinate);
      else addPlaceToMap("Polygon", points, undefined, undefined, mapCoordinate);
    } catch (err) {
      console.error("Routes API fetch error:", err);
      myAlert("Failed to get directions");
    }
  };

  const addPlaceToMap = (PType, Points, directions, name, mapCoordinate) => {
    let shape = "New Place";
    if (PType === "Polygon") shape = "New Area";
    else if (PType === "PolyLine") shape = "New Path";
    let new_place = new Place(window.guide_obj.places);
    new_place.Name = name != null ? name : shape;
    new_place.Lat = mapCoordinate.Lat;
    new_place.Longi = mapCoordinate.Longi;
    new_place.PType = PType;
    new_place.Points = Points;
    if (typeof directions !== "undefined") new_place.Info = directions;
    window.guide_obj.places.addPlace(new_place);
    dispatch(slice1Actions.setShowHiddenPlace({ value: [new_place] }));
    dispatch(slice1Actions.setGuide({ guide: null }));
  };

  const getDirections = () => {
    if (Operation === "Draw") {
      createPath();
      return;
    }
    if (window.DirectionsToLocation === null) {
      myAlert("Must select 'To' place");
      return;
    }
    showDirections();
  };

  const showDirections = () => {
    let waypoints = "";
    if (window.DirectionsWaypointsLocation.length !== 0) {
      waypoints = "&waypoints=";
      for (let i = window.DirectionsWaypointsLocation.length - 1; i >= 0; i--) {
        waypoints += waypoints === "&waypoints=" ? "" : "|";
        waypoints += `${window.DirectionsWaypointsLocation[i].Lat},${window.DirectionsWaypointsLocation[i].Longi}`;
      }
    }
    let _url = `https://www.google.com/maps/dir/?api=1&destination=${window.DirectionsToLocation.Lat},${window.DirectionsToLocation.Longi}${waypoints}`;
    if (window.DirectionsFromLocation !== null)
      _url = `https://www.google.com/maps/dir/?api=1&origin=${window.DirectionsFromLocation.Lat},${window.DirectionsFromLocation.Longi}&destination=${window.DirectionsToLocation.Lat},${window.DirectionsToLocation.Longi}${waypoints}`;
    if (TravelMode === "Walking") _url = _url + "&travelmode=walking";
    else if (TravelMode === "Bicycling") _url = _url + "&travelmode=bicycling";
    else _url = _url + "&travelmode=driving";
    let win = window.open(_url, "_blank");
    if (win) win.focus();
    exitDialog();
  };

  const DeleteDirectionsMarkers = () => {
    window.DirectionsFromLocation = null;
    window.DirectionsToLocation = null;
    window.DirectionsWaypointsLocation = [];
    dispatch(slice1Actions.setDirectionsFromLocation({ value: null }));
    dispatch(slice1Actions.setDirectionsToLocation({ value: null }));
    dispatch(slice1Actions.setDirectionsWaypointsLocation({ value: [] }));
    dispatch(slice1Actions.setGuide({ guide: null }));
    window.DirectionsWaypointPlaces = [];
    window.DirectionsFromPlace = [];
    window.DirectionsToPlace = [];
  };

  const myAlert = (message, title, buttons) => {
    setAlertModalMessage(message);
    setAlertModalTitle(title == null ? "Message" : title);
    setAlertModalButtons(buttons == null ? [{ Title: "OK", Method: null }] : buttons);
    setAlertModalShow(true);
  };

  const displayValueList = (arr) => {
    if (arr === null) return "";
    console.log("displayValueList", arr);
    let str = "";
    for (let i = 0; i < arr.length; i++) {
      if (str != "") str += ", ";
      str += arr[i].Name;
    }
    return str;
  };
  const exitDialog = () => {
    if (typeof props.onHidePrevious != "undefined") props.onHidePrevious();
    props.onHide();
  };

  if (ShowMultiselect)
    return (
      <MultiSelectModal
        show={ShowMultiselect}
        onHide={() => setShowMultiselect(false)}
        MultiselectItems={MultiselectItems}
        MultiselectSelectedItems={MultiselectSelectedItems}
        MultiselectMode={MultiselectMode}
        MultiselectCallback={selectPlacesCallBack}
        MultiselectTitle={MultiselectTitle}
        MultiselectSearchText={MultiselectSearchText}
      />
    );
  else {
    return (
      <div className="modal" style={{ zIndex: 65537 }}>
        <Modal
          {...props}
          dialogClassName="dd-dialog"
          aria-labelledby="contained-modal-title-vcenter"
          centered={false}
          scrollable={false}
          animation={false}
          onHide={exitDialog}
        >
          <Modal.Body style={{ padding: 0 }}>
            <div className="dd-shell">
              <div className="dd-header">
                <div className="dd-header-icon">
                  <FontAwesomeIcon icon={solid("route")} />
                </div>
                <h2 className="dd-title">Directions</h2>
                <button className="dd-close" onClick={exitDialog}>
                  <FontAwesomeIcon icon={solid("xmark")} />
                </button>
              </div>
              <div className="dd-body">
                <div className="dd-section">
                  <span className="dd-section-label">Operation</span>
                  <div className="dd-seg">
                    <button className={`dd-seg-btn${Operation === "Directions" ? " active" : ""}`} onClick={() => setOperation("Directions")}>Directions</button>
                    <button className={`dd-seg-btn${Operation === "Draw" ? " active" : ""}`} onClick={() => setOperation("Draw")}>Draw</button>
                  </div>
                </div>
                {Operation === "Draw" && (
                  <div className="dd-section">
                    <span className="dd-section-label">Shape</span>
                    <div className="dd-seg">
                      <button className={`dd-seg-btn${ShapeToCreate === "Path" ? " active" : ""}`} onClick={() => setShapeToCreate("Path")}>Path</button>
                      <button className={`dd-seg-btn${ShapeToCreate === "Area" ? " active" : ""}`} onClick={() => setShapeToCreate("Area")}>Area</button>
                    </div>
                  </div>
                )}
                <div className="dd-section">
                  <span className="dd-section-label">Travel Mode</span>
                  <div className="dd-seg">
                    <button className={`dd-seg-btn${TravelMode === "Walking" ? " active" : ""}`} onClick={() => setTravelMode("Walking")}>
                      <FontAwesomeIcon icon={solid("person-walking")} /> Walking
                    </button>
                    <button className={`dd-seg-btn${TravelMode === "Bicycling" ? " active" : ""}`} onClick={() => setTravelMode("Bicycling")}>
                      <FontAwesomeIcon icon={solid("bicycle")} /> Bicycling
                    </button>
                    <button className={`dd-seg-btn${TravelMode === "Driving" ? " active" : ""}`} onClick={() => setTravelMode("Driving")}>
                      <FontAwesomeIcon icon={solid("car")} /> Driving
                    </button>
                  </div>
                </div>
                <div className="dd-section">
                  <span className="dd-section-label">Route</span>
                  <div className="dd-card">
                    <button className="dd-selector-row" onClick={() => selectPlaces("from place")}>
                      <FontAwesomeIcon icon={solid("circle-dot")} className="dd-row-icon dd-icon-from" />
                      <span className={`dd-selector-label${DirectionsFromLocation === null ? " placeholder" : ""}`}>
                        {DirectionsFromLocation === null ? "From" : DirectionsFromLocation.Name}
                      </span>
                      <FontAwesomeIcon icon={solid("chevron-right")} className="dd-selector-chevron" />
                    </button>
                    <div className="dd-divider" />
                    <button className="dd-selector-row" onClick={() => selectPlaces("waypoints")}>
                      <FontAwesomeIcon icon={solid("ellipsis-vertical")} className="dd-row-icon dd-icon-waypoint" />
                      <span className={`dd-selector-label${DirectionsWaypointsLocation.length === 0 ? " placeholder" : ""}`}>
                        {DirectionsWaypointsLocation.length === 0 ? "Waypoints (optional)" : displayValueList(DirectionsWaypointsLocation)}
                      </span>
                      <FontAwesomeIcon icon={solid("chevron-right")} className="dd-selector-chevron" />
                    </button>
                    <div className="dd-divider" />
                    <button className="dd-selector-row" onClick={() => selectPlaces("to place")}>
                      <FontAwesomeIcon icon={solid("location-dot")} className="dd-row-icon dd-icon-to" />
                      <span className={`dd-selector-label${DirectionsToLocation === null ? " placeholder" : ""}`}>
                        {DirectionsToLocation === null ? "To" : DirectionsToLocation.Name}
                      </span>
                      <FontAwesomeIcon icon={solid("chevron-right")} className="dd-selector-chevron" />
                    </button>
                  </div>
                </div>
              </div>
              <div className="dd-footer">
                <button className="dd-clear-btn" onClick={() => DeleteDirectionsMarkers()}>Clear</button>
                <button className="dd-go-btn" onClick={() => getDirections()}>
                  <FontAwesomeIcon icon={solid("arrow-right")} /> Go
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
        <AlertModal
          show={AlertModalShow}
          onHide={() => setAlertModalShow(false)}
          AlertModalTitle={AlertModalTitle}
          AlertModalMessage={AlertModalMessage}
          AlertModalButtons={AlertModalButtons}
        />
      </div>
    );
  }
};

export default DirectionsDialog;
